import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Box } from '@chatterbug/aaron'

const AchievementsLiveLessonsSkeleton = ({
  headerSection,
  statsSection,
  listSection,
  paginationSection,
}) => {
  return (
    <Grid gridGap="3x" columns={1}>
      {/* figma is h3 */}
      <Box as="h1" variant="text.h3">
        {headerSection}
      </Box>
      <Box mb="4x">{statsSection}</Box>
      <Box mb="2x">{listSection}</Box>
      <Box justifySelf="center">{paginationSection}</Box>
    </Grid>
  )
}

AchievementsLiveLessonsSkeleton.propTypes = {
  headerSection: PropTypes.any,
  listSection: PropTypes.any,
  paginationSection: PropTypes.any,
  statsSection: PropTypes.any,
}

export default AchievementsLiveLessonsSkeleton
